<div class="grid-container">
	<mat-toolbar style="background-color: transparent">
		<mat-toolbar-row>
			<span>Eventos</span>
			<span class="spacer" style="flex: 1 1 auto"></span>
			<button mat-icon-button class="action" (click)="filters.expanded ? filters.close() : filters.open()" color="accent">
				<mat-icon>filter_list</mat-icon>
			</button>
			<button mat-icon-button routerLink="/events/new" color="accent">
				<mat-icon>add</mat-icon>
			</button>
		</mat-toolbar-row>
	</mat-toolbar>
	<mat-expansion-panel class="mat-elevation-z8 filtersContainer" #filters [style.margin-bottom]="filters.expanded? '16px' : '0px'">
		<section class="filters">
			<mat-form-field appearance="fill" style="margin-bottom:-16px;" color="accent">
				<mat-label>Compañía</mat-label>
				<mat-select [(ngModel)]="selectedCompany" (ngModelChange)="onSelectedCompanyChanged()" [disabled]="!isAdmin">
					<mat-option *ngFor="let company of companyList" [value]="company">
						{{ company.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</section>
		<section class="filters">
			<mat-checkbox class="filter" [checked]="isActiveFilter" [indeterminate]="some('active')" (change)="toggleAll($event.checked, 'active')"> Activos </mat-checkbox>
			<mat-checkbox class="filter" *ngFor="let state of activeStates" [(ngModel)]="state.checked" (ngModelChange)="every('active')" [name]="state.name">
				{{ state.name }}
			</mat-checkbox>
		</section>
		<section class="filters">
			<mat-checkbox class="filter" [checked]="isLiveFilter" [indeterminate]="some('live')" (change)="toggleAll($event.checked, 'live')"> En Vivo </mat-checkbox>
			<mat-checkbox class="filter" *ngFor="let state of liveStates" [(ngModel)]="state.checked" (ngModelChange)="every('live')" [name]="state.name">
				{{ state.name }}
			</mat-checkbox>
		</section>
	</mat-expansion-panel>
	<div>
		<mtx-loader [loading]="loading" type="spinner" color="accent" [hasBackdrop]="true">
			<table mat-table [dataSource]="list" multiTemplateDataRows class="mat-elevation-z8">
				<ng-container matColumnDef="live">
					<th mat-header-cell *matHeaderCellDef></th>
					<td [ngClass]="event.isActive? '' : 'inactive'" mat-cell *matCellDef="let event" style="width: 48px;">
							<mat-icon *ngIf="event.isLive" [style.color]="'#388e3c'">podcasts</mat-icon>
					</td>
				</ng-container>

				<ng-container matColumnDef="date">
					<th mat-header-cell *matHeaderCellDef>Fecha</th>
					<td [ngClass]="event.isActive? '' : 'inactive'" mat-cell *matCellDef="let event">{{ event.fromDate | date: 'MMM dd, YYYY hh:mm a' }}</td>
				</ng-container>

				<ng-container matColumnDef="hour">
					<th mat-header-cell *matHeaderCellDef>Hora</th>
					<td [ngClass]="event.isActive? '' : 'inactive'" mat-cell *matCellDef="let event">{{ event.fromDate | date: 'hh:mm a' }}</td>
				</ng-container>

				<ng-container matColumnDef="company">
					<th mat-header-cell *matHeaderCellDef>Compañía</th>
					<td [ngClass]="event.isActive? '' : 'inactive'" mat-cell *matCellDef="let event">{{ event.company?.name}}</td>
				</ng-container>

				<ng-container matColumnDef="client">
					<th mat-header-cell *matHeaderCellDef>Cliente</th>
					<td [ngClass]="event.isActive? '' : 'inactive'" mat-cell *matCellDef="let event">{{ event.client?.name }}</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef>Evento</th>
					<td [ngClass]="event.isActive? '' : 'inactive'" mat-cell *matCellDef="let event">{{ event.name }}</td>
				</ng-container>

				<ng-container matColumnDef="channels">
					<th mat-header-cell *matHeaderCellDef>Canales</th>
					<td [ngClass]="event.isActive? '' : 'inactive'" mat-cell *matCellDef="let event">
						<span
							*ngFor="let channel of event.channels"
							[style.background-color]="channel.backgroundColor"
							class="event-card-content-chip"
							style="margin-right: 1.25px; padding: 2.5px; font-size: 12px"
						>
							<span *ngIf="!channel.alias" [style.color]="channel.color">{{ channel.name }}</span>
							<span *ngIf="channel.alias" [style.color]="channel.color">{{ channel.alias }}</span>
						</span>
					</td>
				</ng-container>

				<!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
				<ng-container matColumnDef="expandedDetail">
					<td mat-cell *matCellDef="let event" [attr.colspan]="displayedColumns.length">
						<div class="event-detail" [@detailExpand]="event == expandedEvent ? 'expanded' : 'collapsed'">
							<div class="action-cards-container">
								<!-- Event Management Card -->
								<mat-card class="action-card">
									<mat-card-header>
										<mat-card-title class="card-title">
											<mat-icon class="section-icon">settings</mat-icon>
											Gestión
										</mat-card-title>
									</mat-card-header>
									<mat-card-content>
										<div class="action-buttons">
											<button 
												mat-fab 
												color="primary" 
												class="action-button" 
												(click)="goToUpdate(event)" 
												[disabled]="!event.isActive"
												matTooltip="Editar evento"
												matTooltipPosition="above">
												<mat-icon>edit</mat-icon>
											</button>
											<span class="button-label">Editar</span>
										</div>
									</mat-card-content>
								</mat-card>

								<!-- Live Controls Card -->
								<mat-card class="action-card">
									<mat-card-header>
										<mat-card-title class="card-title">
											<mat-icon class="section-icon">podcasts</mat-icon>
											Transmisión
										</mat-card-title>
									</mat-card-header>
									<mat-card-content>
										<div class="action-buttons-row">
											<div class="action-buttons">
												<button 
													mat-fab 
													color="primary" 
													class="action-button" 
													(click)="goToHost(event)" 
													[disabled]="!event.isActive"
													matTooltip="Modo anfitrión"
													matTooltipPosition="above">
													<mat-icon>interpreter_mode</mat-icon>
												</button>
												<span class="button-label">Anfitrión</span>
											</div>
											<div class="action-buttons">
												<button 
													mat-fab 
													color="primary" 
													class="action-button" 
													(click)="goToAudience(event)" 
													[disabled]="!event.isActive"
													matTooltip="Vista de audiencia"
													matTooltipPosition="above">
													<mat-icon>headphones</mat-icon>
												</button>
												<span class="button-label">Audiencia</span>
											</div>
										</div>
									</mat-card-content>
								</mat-card>

								<!-- Integration Card -->
								<mat-card class="action-card">
									<mat-card-header>
										<mat-card-title class="card-title">
											<mat-icon class="section-icon">integration_instructions</mat-icon>
											Integración
										</mat-card-title>
									</mat-card-header>
									<mat-card-content>
										<div class="action-buttons-row">
											<div class="action-buttons">
												<button 
													mat-fab 
													color="primary" 
													class="action-button" 
													(click)="getEmbeddableCode(event)" 
													[disabled]="!event.isActive"
													matTooltip="Código embebido"
													matTooltipPosition="above">
													<mat-icon>code</mat-icon>
												</button>
												<span class="button-label">Código</span>
											</div>
											<div class="action-buttons">
												<button 
													mat-fab 
													color="primary" 
													class="action-button" 
													(click)="getShareableCode(event)" 
													[disabled]="!event.isActive"
													matTooltip="Código QR compartible"
													matTooltipPosition="above">
													<mat-icon>qr_code</mat-icon>
												</button>
												<span class="button-label">QR Code</span>
											</div>
										</div>
									</mat-card-content>
								</mat-card>

								<!-- Participants Card -->
								<mat-card class="action-card">
									<mat-card-header>
										<mat-card-title class="card-title">
											<mat-icon class="section-icon">groups</mat-icon>
											Participantes
										</mat-card-title>
									</mat-card-header>
									<mat-card-content>
										<div class="action-buttons">
											<button 
												mat-fab 
												color="primary" 
												class="action-button" 
												(click)="goToAttendees(event)" 
												[disabled]="!event.isActive"
												matTooltip="Ver asistentes"
												matTooltipPosition="above">
												<mat-icon>groups</mat-icon>
											</button>
											<span class="button-label">Asistentes</span>
										</div>
									</mat-card-content>
								</mat-card>

								<!-- Status Controls Card -->
								<mat-card class="action-card status-card">
									<mat-card-header>
										<mat-card-title class="card-title">
											<mat-icon class="section-icon">power_settings_new</mat-icon>
											Control de Estado
										</mat-card-title>
									</mat-card-header>
									<mat-card-content>
										<div class="status-controls">
											<div class="status-item">
												<div class="status-info">
													<span class="status-label">Estado en vivo:</span>
													<span class="status-badge" [ngClass]="event.isLive ? 'live-active' : 'live-inactive'">
														{{ event.isLive ? 'Activo' : 'Inactivo' }}
													</span>
												</div>
												<button 
													mat-button 
													[color]="event.isLive ? 'danger' : 'primary'"
													class="status-toggle-button" 
													[disabled]="!event.isActive" 
													(click)="toggleLiveState(event)"
													[matTooltip]="event.isLive ? 'Terminar transmisión' : 'Iniciar transmisión'"
													matTooltipPosition="above">
													<mat-icon *ngIf="!event.isLive" class="live-icon-inactive">mic</mat-icon>
													<mat-icon *ngIf="event.isLive" class="live-icon-active">mic_off</mat-icon>
												</button>
											</div>
											<mat-divider></mat-divider>
											<div class="status-item">
												<div class="status-info">
													<span class="status-label">Estado del evento:</span>
													<span class="status-badge" [ngClass]="event.isActive ? 'event-active' : 'event-inactive'">
														{{ event.isActive ? 'Activo' : 'Inactivo' }}
													</span>
												</div>
												<button 
													mat-button 
													[color]="event.isActive ? 'warn' : 'primary'"
													class="status-toggle-button" 
													[disabled]="event.isLive" 
													(click)="toggleActiveState(event)"
													[matTooltip]="event.isActive ? 'Desactivar evento' : 'Activar evento'"
													matTooltipPosition="above">
													<mat-icon *ngIf="!event.isActive" class="active-icon-inactive">check_circle</mat-icon>
													<mat-icon *ngIf="event.isActive" class="active-icon-active">cancel</mat-icon>
												</button>
											</div>
										</div>
									</mat-card-content>
								</mat-card>
							</div>
						</div>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					[class.example-expanded-row]="expandedEvent === row"
					(click)="expandedEvent = expandedEvent === row ? null : row"
				></tr>
				<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
			</table>
			<mat-paginator
				class="mat-elevation-z8"
				[length]="listLength"
				[pageSize]="pageSize"
				(page)="pageChanged($event)">
			</mat-paginator>
		</mtx-loader>
	</div>
</div>
